interface IUrl{
    url  : string
    title: string
    data : any
}
export class Url {
    private static urls:any = null;
    private static historyUrls:Array<IUrl> = [];

    public static get(field:string):string{
        if ( this.urls === null ) {
            this.urls = {};
            var url = decodeURIComponent(window.location.href);
            var firstParamIndex:number = url.indexOf('?');
            if ( firstParamIndex > -1 ) {
                var paramsString = url.substr(firstParamIndex+1)
                var temp:Array<string> = null;
                if ( paramsString.indexOf('&') > -1 ) {
                    temp = paramsString.split('&');
                }else{
                    temp = [paramsString];
                }
                for (var key in temp) {
                    var item = temp[key].split('=');
                    this.urls[item[0]] = item[1];
                }
            }
        }
        if ( this.urls[field] !== undefined ) {
            return this.urls[field];
        }else{
            return null;
        }
    }

    public static emptyAll(){
        this.urls        = null;
        this.historyUrls = [];
    }

    public static setUrl(url:string, data:any=null, title:string=null):string{
        if (  url === '-1' ) {
            let lastUrl = this.historyGetLast();
            if (  lastUrl !== null && lastUrl.url !== ('/'+ Url.getUrl()) ) {
                url         = lastUrl.url;
                data        = lastUrl.data;
                title       = lastUrl.title;
            }else{
                url = '';
                if (  document.body.classList.contains('user') ) {
                    url = '/user/index';
                }else
                if (  document.body.classList.contains('service') ) {
                    url = '/restaurant/index';
                }else
                if (  document.body.classList.contains('admin') ) {
                    url = '/admin/index';
                }

            }
        }else{
            this.historyAdd(url,title,data);
        }
        history.pushState(data, title, url);
        return url;
    }

    private static historyAdd(url: string, title: string, data: any) {
        let lastUrl = this.historyGetLast();
        if ( lastUrl === null || (lastUrl.url !== url && JSON.stringify(lastUrl.data) !== JSON.stringify(data) ) ) {
            this.historyUrls.push({
                url: url,
                title: url,
                data: url,
            });
        }
    }

    private static historyGetLast():IUrl{
        let index = this.historyUrls.length-2;
        if (  index >= 0 ) {
            if ( this.historyUrls[index] !== undefined ) {
                if ( this.historyUrls[index].toString() !== Url.getUrl() ) {
                    return this.historyUrls[index];
                }

            }
        }
        return null;
    }

    public static getUrl():string{
        return window.location.pathname.substr(1);
    }

    public static isUrl(pattern:RegExp):boolean {
        return pattern.test(this.getUrl());
    }

    public static getUrlPart(part:number):string {
        var temp:Array<string> = this.getUrl().split('/');
        if (  temp[part] !== undefined ) {
            return temp[part];
        }else{
            console.error('getUrlPart error, not found url part');
        }
        return null;
    }

    public static isIOS():boolean {
        return device.platform === 'iOS';
    }

    public static isBrowser():boolean {
        return device.platform === 'browser';
    }

    public static isSafari(justBrowserCheck:boolean=false):boolean{
        if ( justBrowserCheck === false ) {
            if ( device.platform === 'iOS' ) {
                return true;
            }
            if ( device.platform === 'Android' ) {
                return false;
            }
        }
        return navigator.userAgent.toLowerCase().indexOf('safari')>-1 && navigator.userAgent.toLowerCase().indexOf('chrome')=== -1;
    }
}
